import { render, staticRenderFns } from "./SurveyManagementEditRatingReasons.vue?vue&type=template&id=56c0166a&scoped=true&"
import script from "./SurveyManagementEditRatingReasons.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementEditRatingReasons.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementEditRatingReasons.vue?vue&type=style&index=0&id=56c0166a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c0166a",
  null
  
)

/* custom blocks */
import block0 from "./SurveyManagementEditRatingReasons.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c0166a')) {
      api.createRecord('56c0166a', component.options)
    } else {
      api.reload('56c0166a', component.options)
    }
    module.hot.accept("./SurveyManagementEditRatingReasons.vue?vue&type=template&id=56c0166a&scoped=true&", function () {
      api.rerender('56c0166a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/questions/SurveyManagementEditRatingReasons.vue"
export default component.exports